import React, { Component } from "react";
import { Redirect } from "react-router";
import accountService from "../../../services/AccountService";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import Type from "../../Global/Typography.js";

import NanoFlex from "./../../Global/NanoFlex.js";
import Loading from "./../../Nano/Loading.js";
import Button from "./../../Nano/Buttons/Button.js";

//Images
import backgroundImage from "../../../images/bck-login.svg";
import { ReactComponent as Warning } from "../../Global/Icons/warning.svg";
import { ReactComponent as Check } from "../../Global/Icons/check.svg";

const multiple = nota.global.multiple;

const StyledUnSubscribe = styled(NanoFlex)`
  height: 100vh;
  background-color: ${nota.color.main.default};
  background-image: url(${backgroundImage});
  background-repeat: no-repeat, repeat;
  background-size: cover;
  background-position: center;

  .containerInfo {
    background-color: ${nota.color.neutral.lightGrey};
    width: 350px;
    height: auto;
    padding: ${multiple * 6 + "px"}; /*24px*/
    .formWrapper {
      .formContainer {
        .form-wrapper {
          width: 100%;
          .passwordInvalid {
            height: auto;
            text-align: center;
            h6 {
              color: ${(props) => (props.passwordInvalid ? nota.color.main.mTwo : nota.color.neutral.NeuOne)};
            }
          }
          .buttonsWrapper {
            margin-top: 16px;
            .buttonWrapper {
              width: 100%;
              text-align: center;
            }
          }
        }
      }
    }
  }

  /* ERROR NOTIFICATION */
  .alertNotificationContainer {
    height: 32px;
    margin-top: ${multiple * 2 + "px"};
  }

  .alertNotificationWrapper {
    height: auto;
    width: 100%;

    .alertWrapper {
      padding: ${multiple + "px"};
      .iconWrapper {
        width: auto;
        margin: 0 ${multiple * 2 + "px"};
        svg {
          width: auto;
          height: 16px;
        }
      }
    }
  }
  .errorNotification {
    background-color: ${nota.color.main.mTwo};
    .iconWrapper {
      svg {
        path {
          fill: ${nota.color.neutral.white};
        }
      }
    }
    .notificationWrapper {
      p {
        color: ${nota.color.neutral.white};
      }
    }
  }

  /* NOTIFICATION */
  .wrapperNotification {
    .iconWrapper {
      padding: ${multiple * 3 + "px"};
      svg {
        height: 100px;
        width: auto;
      }
    }
    .infoNotification {
      text-align: center;
      padding: ${multiple * 8 + "px"} ${multiple * 3 + "px"};
      h3 {
        color: ${nota.color.neutral.NeuOne};
        text-transform: uppercase;
        font-weight: bold;
      }
    }
  }

  @media only screen and (max-width: 374px) {
    .containerInfo {
      width: 75%;
      width: 272px;
      padding: 48px 24px;
      .wrapperNotification {
        .infoNotification {
          padding: 64px 8px;
        }
      }
    }
  }
`;

const StyledLoading = styled(NanoFlex)`
  height: 100vh;
`;

export class UnSubscribe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unSubscribeStatus: null,
    };
  }

  componentDidMount() {
    this.unSubscribeDailyUpdate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.redirectToLogin) this.setState({ redirectToLogin: false });
  }

  unSubscribeDailyUpdate = () => {
    accountService
      .disableDailyUpdate(this.props.match.params.idLetter, this.props.match.params.idUser)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ unSubscribeStatus: data });
      });
  };

  redirectToLogin = () => {
    this.setState({ redirectToLogin: true });
  };

  render() {
    if (this.state.redirectToLogin) return <Redirect to="/login" />;
    return (
      <StyledUnSubscribe passwordInvalid={this.state.passwordInvalid}>
        {this.state.unSubscribeStatus === null && (
          <StyledLoading className="loadingContainer">
            <Loading />
          </StyledLoading>
        )}
        {this.state.unSubscribeStatus !== null && (
          <NanoFlex className="containerInfo">
            {this.state.unSubscribeStatus === false && (
              <NanoFlex className="wrapperNotification" flexDirection="column">
                <NanoFlex className="iconWrapper">
                  <Warning />
                </NanoFlex>
                <NanoFlex className="infoNotification">
                  <Type.h3>This link is no longer available!</Type.h3>
                </NanoFlex>
                <NanoFlex className="buttonsWrapper" flexDirection="column">
                  <Button id={1} label={"Back to Login"} type={"button"} simple clickAction={this.redirectToLogin} />
                </NanoFlex>
              </NanoFlex>
            )}

            {this.state.unSubscribeStatus === true && (
              <NanoFlex className="wrapperNotification" flexDirection="column">
                <NanoFlex className="iconWrapper">
                  <Check />
                </NanoFlex>

                <NanoFlex className="infoNotification">
                  <Type.h3>DailyUpdate Unsubscribed successfully!</Type.h3>
                </NanoFlex>
                <NanoFlex className="buttonsWrapper" flexDirection="column">
                  <Button id={1} label={"Back to Login"} type={"button"} simple clickAction={this.redirectToLogin} />
                </NanoFlex>
              </NanoFlex>
            )}
          </NanoFlex>
        )}
      </StyledUnSubscribe>
    );
  }
}
